import { ThemeColors } from '@pimm/base';

// Hex values resolved via useTheme() — required by victory-native
// blueLight.400 → above forecast  |  error.300 → below forecast  |  gray.200 → future
export const BAR_COLORS = {
  above: ThemeColors.blueLight[400],
  below: ThemeColors.error[300],
  future: ThemeColors.gray[200],
};

export const LABOR_VARIANCE_THRESHOLDS = {
  thirtyMin: { actualToGuide: { yellow: 0.5, red: 1.0 }, cumulative: { yellow: null, red: 5.0 } },
  sixtyMin: { actualToGuide: { yellow: 1.0, red: 2.0 }, cumulative: { yellow: null, red: 5.0 } },
};

// Layout — keeps chart X-axis aligned with table columns
export const LAYOUT = {
  stickyLabelW: 130, // sticky row-label column width (px)
};

export const CHART_LAYOUT = {
  // Y-axis label area width — adjust to fit your longest tick label
  yAxisW: 60,
  paddingTop: 20,
  paddingBottom: 0,
  height: 220,
};

// Tile dimensions
export const TILE = {
  height: 120,
  defaultW: 195,
  todayW: 220,
  gap: 8,
};
